import { ModulesConfigMap, ModulesMap } from '../data/modulesMaps'
// import { STORE_MAP } from '@/config/cache/cache-engine'

export default {
	getLogisticRoutes: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES].GET_LOGISTIC_ROUTES,
	},
	getLogisticRoutePreview: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES].GET_LOGISTIC_ROUTE_PREVIEW,
	},
	getLogisticRoutePopup: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES].GET_LOGISTIC_ROUTE_POPUP,
	},
	getLogisticRoute: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES].GET_LOGISTIC_ROUTE,
	},
	createLogisticRoute: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES].CREATE_LOGISTIC_ROUTE,
	},
	putLogisticRoute: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES].PUT_LOGISTIC_ROUTE,
	},
	patchLogisticRoute: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES].PATCH_LOGISTIC_ROUTE,
	},
	deleteLogisticRoute: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES].DELETE_LOGISTIC_ROUTE,
	},
}
